import useOcapiSite from '../../hooks/useOcapiSite'
import {useKlarna} from '../klarna-pay-later/context'

/**
 * @param {Object} props
 * @param {number} [props.amount]
 * @param {string} [props.currency]
 * @param {string} [props.paypalPlacement]
 * @param {string} [props.klarnaPlacement]
 * @returns {{isPaypalEnabled: boolean, isKlarnaEnabled: boolean}}
 */
const usePayLater = ({amount, currency, paypalPlacement, klarnaPlacement}) => {
    const {enablePaypalLater, paypalLaterClientID} = useOcapiSite().customPreferences
    const {options: klarnaOptions} = useKlarna()

    const isPaypalEnabled = Boolean(
        paypalPlacement && enablePaypalLater && paypalLaterClientID && amount > 0 && currency
    )
    const isKlarnaEnabled = Boolean(klarnaPlacement && klarnaOptions.enabled && amount > 0)

    return {isPaypalEnabled, isKlarnaEnabled}
}

export default usePayLater
